import * as React from "react";
import * as AccordionPrimitive from "@radix-ui/react-accordion";
import { LuChevronDown } from "react-icons/lu";
import { cn } from "../../lib/utils";
import { ACCORDION_STYLES } from "./constants";
import { AccordionItemProps, AccordionTriggerProps, AccordionContentProps } from "./types";

const Accordion = AccordionPrimitive.Root;

const AccordionItem = React.forwardRef<
  React.ElementRef<typeof AccordionPrimitive.Item>,
  AccordionItemProps
>(({ className, ...props }, ref) => (
  <AccordionPrimitive.Item
    ref={ref}
    className={cn(ACCORDION_STYLES.item, className)}
    {...props}
  />
));
AccordionItem.displayName = "AccordionItem";

const AccordionTrigger = React.forwardRef<
  React.ElementRef<typeof AccordionPrimitive.Trigger>,
  AccordionTriggerProps
>(({ className, children, ...props }, ref) => (
  <AccordionPrimitive.Header className="flex">
    <AccordionPrimitive.Trigger
      ref={ref}
      className={cn(
        ACCORDION_STYLES.trigger,
        className
      )}
      {...props}
    >
      {children}
      <LuChevronDown className="h-4 w-4 shrink-0 text-ticketon-lighter-blue transition-transform duration-200" />
    </AccordionPrimitive.Trigger>
  </AccordionPrimitive.Header>
));
AccordionTrigger.displayName = AccordionPrimitive.Trigger.displayName;

const AccordionContent = React.forwardRef<
  React.ElementRef<typeof AccordionPrimitive.Content>,
  AccordionContentProps
>(({ className, children, ...props }, ref) => (
  <AccordionPrimitive.Content
    ref={ref}
    className={ACCORDION_STYLES.content}
    {...props}
  >
    <div className={cn(ACCORDION_STYLES.contentInner, className)}>{children}</div>
  </AccordionPrimitive.Content>
));
AccordionContent.displayName = AccordionPrimitive.Content.displayName;

export { Accordion, AccordionItem, AccordionTrigger, AccordionContent };
